module.exports = __webpack_public_path__ + "img/sac-home-sidebar.f1b6adec.jpg";